export const SIZE_MAP = {
  '100': 'xxxs',
  '100.5': 'xxxs/xxs',
  '101': 'xxs',
  '101.5': 'xxs/xs',
  '102': 'xs',
  '102.5': 'xs/s',
  '103': 's',
  '103.5': 's/m',
  '104': 'm',
  '104.5': 'm/l',
  '105': 'l',
  '105.5': 'l/xl',
  '106': 'xl',
  '106.5': 'xl/2xl',
  '107': 'xxl',
  '107.5': '2xl/3xl',
  '108': '3xl',
  '108.5': '3xl/4xl',
  '109': '4xl',
  '200': 'one size',
};
